import type { RouteRecordRaw, Router } from 'vue-router'

const BankingRoutes: RouteRecordRaw = {
  path: '/claim/banking',
  name: 'BankingModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'BankingMainRoute',
      component: () => import('./views/BankingView.vue'),
      meta: {
        title: 'banking.bankingClaims',
      },
    },
    {
      path: 'create',
      name: 'BankingCreateRoute',
      component: () => import('./views/BankingUpsertView.vue'),
      meta: {
        title: 'banking.createBanking',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:bankingId',
      name: 'BankingEditRoute',
      component: () => import('./views/BankingUpsertView.vue'),
      meta: {
        title: 'banking.editBanking',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:bankingId',
      name: 'ViewBankingRoute',
      component: () => import('./views/SingleBankingView.vue'),
      meta: {
        title: 'banking.ViewBanking',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(BankingRoutes)
}
